const translations = {
  title: 'Nueva Actividad',
  title_edit: 'Editando Actividad',
  title_reopening: 'Reabriendo Actividad',
  bulkRegistration: 'Registro masivo',
  name: 'Nombre',
  checklist: 'Cuestionario*',
  placeType: 'Tipo de destino',
  place: 'Destino*',
  asset: 'Activo',
  responsible: 'Responsable',
  address: 'Dirección',
  scheduling: 'Fecha de agendamiento',
  priority: 'Prioridad',
  tag: 'Tag',
  lockReasons: 'Motivos de bloqueo',
  additionalFields: 'Campos adicionales',
  description: 'Descripción',
  addFile: 'Agregar Archivo'
}

export default translations
